<footer [ngStyle]="{backgroundColor: backgroundColor, color: textColor}" id="ev-footer">
  <div>
    <a class="links" href="https://www.iubenda.com/privacy-policy/30177661" target="_blank">Privacy Policy</a> |
    <a class="links" href="https://www.iubenda.com/privacy-policy/30177661/cookie-policy" target="_blank">Cookie Policy</a> |
    <a class="links iubenda-cs-preferences-link" href="#">Aggiorna le tue preferenze di tracciamento</a>
  </div>
  <div *ngIf="showVersion" class="version-number">
    <span>Version: {{ version }}</span>
  </div>
</footer>
